import { ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../ui/button"
import { useEffect } from "react"
import React from "react"

export function PaginationControls({
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
}: {
  currentPage: number
  totalPages: number
  onPreviousPage: () => void
  onNextPage: () => void
}) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [currentPage])

  return (
    <div className="flex items-center gap-1 bg-white border border-slate-200 rounded-lg px-2 py-1 mt-4 justify-center">
      {/* Previous button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onPreviousPage}
        disabled={currentPage === 1}
        className="h-8 w-8 p-0 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeft className="h-4 w-4" />
        <span className="sr-only">Previous page</span>
      </Button>

      <div className="flex items-center px-3 py-1">
        <span className="text-sm font-medium text-slate-900 min-w-[60px] text-center">{currentPage}</span>
        <span className="text-sm text-slate-500 mx-1">of</span>
        <span className="text-sm font-medium text-slate-900 min-w-[60px] text-center">{totalPages}</span>
      </div>

      {/* Next button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onNextPage}
        disabled={currentPage === totalPages}
        className="h-8 w-8 p-0 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronRight className="h-4 w-4" />
        <span className="sr-only">Next page</span>
      </Button>
    </div>
  )
}
